import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import { CodeSplitter } from './Shared/Components/CodeSplitter';

export function Routes(): React.ReactElement {
  return (
    <Switch>
      <Route
        exact
        path="/components/edit/:componentId?"
        component={() => (
          <CodeSplitter name="EditComponent" import={() => import('./Pages/Components/EditComponent')} />
        )}
      />
      <Route
        exact
        path="/components"
        component={() => <CodeSplitter name="Components" import={() => import('./Pages/Components/Components')} />}
      />

      <Route
        exact
        path="/applications/:applicationId/Views/:viewId/contents/edit/:contentId?"
        component={() => <CodeSplitter name="EditContent" import={() => import('./Pages/Contents/EditContent')} />}
      />
      <Route
        exact
        path="/applications/:applicationId/Views/:viewId/contents/copy/:contentId?"
        component={() => <CodeSplitter name="CopyContent" import={() => import('./Pages/Contents/CopyContent')} />}
      />
      <Route
        exact
        path="/applications/:applicationId/Views/:viewId/contents"
        component={() => <CodeSplitter name="Contents" import={() => import('./Pages/Contents/Contents')} />}
      />
      <Route
        exact
        path="/applications/:applicationId/Views/edit/:viewId?"
        component={() => <CodeSplitter name="EditView" import={() => import('./Pages/Views/EditView')} />}
      />
      <Route
        exact
        path="/applications/:applicationId/views"
        component={() => <CodeSplitter name="Views" import={() => import('./Pages/Views/Views')} />}
      />

      <Route
        exact
        path="/applications/edit/:applicationId?"
        component={() => (
          <CodeSplitter name="EditApplication" import={() => import('./Pages/Applications/EditApplication')} />
        )}
      />
      <Route
        exact
        path="/"
        component={() => (
          <CodeSplitter name="Applications" import={() => import('./Pages/Applications/Applications')} />
        )}
      />
    </Switch>
  );
}
